<template>
  <div
    class="min-h-screen bg-gray-50 px-4 py-6 pb-24 brands-page"
    dir="rtl"
    :class="{ 'brands-skeleton-group': pageLoading }"
  >
    <div class="mx-auto max-w-lg md:max-w-none">

      <!-- Skeleton -->
      <div v-if="pageLoading" class="picker-list" aria-hidden="true">
        <div
          v-for="n in skeletonCardCount"
          :key="'brand-sk-' + n"
          class="picker-card picker-card--skeleton"
        >
          <div class="picker-card__inner">
            <div class="picker-card__main">
              <div class="skeleton-block picker-skeleton-icon"></div>
              <div class="skeleton-block picker-skeleton-title"></div>
            </div>
            <div class="skeleton-block picker-skeleton-chevron"></div>
          </div>
        </div>
      </div>

      <!-- Empty State -->
      <div v-else-if="items.length === 0" class="flex flex-col items-center justify-center py-20">
        <div class="w-24 h-24 rounded-full bg-gray-100 flex items-center justify-center mb-4">
          <svg class="w-12 h-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
        </div>
        <p class="text-gray-500 text-sm">هنوز برندی اضافه نشده است</p>
      </div>

      <!-- Brands List -->
      <div v-else class="picker-list">
        <button
          v-for="item in items"
          :key="item.Id"
          type="button"
          class="picker-card"
          :class="{ 'picker-card--selected': item.Id == selected_item_id }"
          @click="goToModel(item.Id, item.SubGroupTitle)"
        >
          <div class="picker-card__inner">
            <div class="picker-card__main">
              <div class="picker-card__icon">
                <img
                  :src="item.ImageUrl"
                  :alt="item.SubGroupTitle"
                  class="picker-card__icon-img"
                />
              </div>
              <h3 class="picker-card__title">{{ item.SubGroupTitle }}</h3>
            </div>
            <svg class="picker-card__chevron" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
            </svg>
          </div>
        </button>
      </div>

    </div>

    <!-- Model Selection Dialog -->
    <div v-if="dialog_model" class="fixed inset-0 bg-black bg-opacity-50 z-999 flex items-center justify-center p-4" @click.self="dialog_model = false">
      <div class="bg-white rounded-xl shadow-xl w-full max-w-2xl max-h-90vh overflow-hidden flex flex-col">
        <div class="px-6 py-4 bg-gradient-to-r from-blue-600 to-blue-700">
          <h2 class="text-lg font-bold text-white">{{ $t('deviceModel') }}</h2>
        </div>

        <div class="px-6 py-4 overflow-y-auto flex-1 min-h-400px">
          <div class="space-y-4">
            <treeselect
              :multiple="false"
              :load-options="load_models"
              :normalizer="normalizer_models"
              :async="true"
              :placeholder="$t('searchDeviceModel')"
              v-model="auto_complete_model"
            />

            <div v-if="model_txt" class="bg-blue-50 border border-blue-200 rounded-lg p-3">
              <p class="text-xs text-gray-600 mb-1">{{ $t('selectedModel') }}</p>
              <p class="font-bold text-gray-900">{{ model_txt }}</p>
            </div>
          </div>
        </div>

        <div class="px-6 py-4 border-t border-gray-200 flex gap-3">
          <button
            class="flex-1 px-6 py-3 bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium rounded-lg transition-colors duration-200"
            @click="dialog_model = false"
          >
            {{ $t('cancel') }}
          </button>
          <button
            v-if="model_txt != ''"
            class="flex-1 px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-medium rounded-lg transition-all duration-200"
            @click="goToDetail()"
          >
            {{ $t('ok') }}
          </button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import Treeselect from '@riophae/vue-treeselect'
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'
  import { ASYNC_SEARCH } from '@riophae/vue-treeselect'
  import { skeletonSilentRequest } from '../../utils/skeletonPages'

  const simulateAsyncOperation = fn => {
    setTimeout(fn, 200)
  }

  export default {
    components: { Treeselect },

    data () {
      return {
        auto_complete_model: null,
        search_entries: [],
        model_txt: '',
        selected_item_id: '',
        loading: false,
        select: null,
        model_items: [],
        items: [],
        errors: [],
        form_valid: false,
        device_model: '',
        dialog_model: '',
        pageLoading: true,
        skeletonCardCount: 11,
        normalizer_models (node) {
          return {
            id: node.Id,
            label: node.Title,
          }
        },
      }
    },
    watch: {
      auto_complete_model () {
        for (var i = 0; i < this.search_entries.length; i++) {
          if (this.search_entries[i].Id == this.auto_complete_model) {
            this.model_txt = this.search_entries[i].Title
          }
        }
      },

      select (val) {
        console.log('select', val)
      }
    },
    async mounted () {
      const passing_data = JSON.parse(localStorage.getItem('request_data'))
      console.log('request data', passing_data)
      console.log('request data model', passing_data.model_title)
      this.selected_item_id = passing_data.brand_id
      if (passing_data.model_title != null) {
        this.device_model = passing_data.model_title
        this.model_txt = passing_data.model_title
        console.log('title is', this.device_model)
      }

      try {
        await this.get_categories()
      } finally {
        this.pageLoading = false
      }
    },
    methods: {
      load_models ({ action, searchQuery, callback }) {
        this.model_txt = searchQuery
        var self = this
        if (action === ASYNC_SEARCH) {
          simulateAsyncOperation(() => {
            var passing_data = JSON.parse(localStorage.getItem('request_data'))

            const send_data = {
              txt: searchQuery,
              sgid: passing_data.brand_id,
            }
            this.axios.post('/GetProductModels', send_data, skeletonSilentRequest)
              .then(response => {
                self.search_entries = response.data.results
                callback(null, response.data.results)
              }).catch(e => {
              this.errors.push(e)
            })
          })
        }
      },

      goToModel (item_id, title) {
        var passing_data = JSON.parse(localStorage.getItem('request_data'))
        passing_data.brand_id = item_id
        passing_data.request_name = passing_data.request_name + title + ' '

        localStorage.setItem('request_data', JSON.stringify(passing_data))
        this.dialog_model = true
      },
      goToDetail () {
        var passing_data = JSON.parse(localStorage.getItem('request_data'))
        passing_data.device_model = this.model_txt
        if (this.auto_complete_model == null) {
          passing_data.device_model_id = 0
        } else {
          passing_data.device_model_id = this.auto_complete_model
        }

        localStorage.setItem('request_data', JSON.stringify(passing_data))
        this.$router.push({ name: 'predefined', params: {} })
      },
      async get_categories () {
        const passing_data = JSON.parse(localStorage.getItem('request_data'))
        const sub_group_id = passing_data.sub_group_id
        const send_data = {
          groupId: sub_group_id,
        }

        try {
          const response = await this.axios.post('/GetReqCategorySubGroupListRelByGrpId', send_data, skeletonSilentRequest)
          if (response.data.error == 0) {
            console.log('brands get ' + response.data.subGroups)
            this.items = response.data.subGroups || []
          }
        } catch (e) {
          this.errors.push(e)
        }
      }
    }
  }
</script>
<style scoped>
  .picker-list {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .picker-card {
    display: block;
    width: 100%;
    text-align: right;
    background: #fff;
    border: 1px solid #e8ecf1;
    border-radius: 0.75rem;
    padding: 0.75rem 1rem;
    cursor: pointer;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
  }

  .picker-card:hover {
    border-color: #bfdbfe;
    box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);
  }

  .picker-card:active {
    transform: scale(0.995);
  }

  .picker-card--selected {
    background: #eff6ff;
    border-color: #93c5fd;
  }

  .picker-card__inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    width: 100%;
  }

  .picker-card__main {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    flex: 1;
    min-width: 0;
  }

  .picker-card__icon {
    flex-shrink: 0;
    width: 2.75rem;
    height: 2.75rem;
    padding: 0.5rem;
    border-radius: 0.625rem;
    background: #eef4ff;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }

  .picker-card__icon-img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .picker-card__title {
    flex: 1;
    min-width: 0;
    margin: 0;
    font-size: 0.9375rem;
    font-weight: 700;
    line-height: 1.4;
    color: #1e3a5f;
  }

  .picker-card__chevron {
    flex-shrink: 0;
    width: 1.25rem;
    height: 1.25rem;
    color: #9ca3af;
  }

  .brands-skeleton-group {
    position: relative;
    overflow: hidden;
    pointer-events: none;
    user-select: none;
  }

  .brands-skeleton-group::after {
    content: '';
    position: absolute;
    inset: 0;
    z-index: 1;
    pointer-events: none;
    transform: translateX(-100%);
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.55) 45%,
      rgba(255, 255, 255, 0.65) 55%,
      rgba(255, 255, 255, 0) 100%
    );
    animation: brands-skeleton-shimmer 1.4s ease-in-out infinite;
  }

  .skeleton-block {
    background-color: #e5e7eb;
  }

  .picker-skeleton-icon {
    width: 2.75rem;
    height: 2.75rem;
    border-radius: 0.625rem;
    flex-shrink: 0;
  }

  .picker-skeleton-title {
    flex: 1;
    height: 0.9375rem;
    max-width: 10rem;
    border-radius: 6px;
  }

  .picker-skeleton-chevron {
    width: 1.25rem;
    height: 1.25rem;
    border-radius: 4px;
    flex-shrink: 0;
  }

  @keyframes brands-skeleton-shimmer {
    100% {
      transform: translateX(100%);
    }
  }
</style>
